module.exports = __webpack_public_path__ + "static/beepbeephamper-9bf8807efc8e6fab8c8287f2b594cd3e.jpeg";